<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px; padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.type"
              placeholder="问题类别"
              clearable
              style="width:100%"
            >
              <el-option
                label="单选题"
                value="2"
              />
              <el-option
                label="多选题"
                value="3"
              />
              <el-option
                label="问答题"
                value="4"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.question"
              placeholder="问题内容"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.status"
              placeholder="状态"
              clearable
              style="width:100%"
            >
              <el-option
                label="草稿"
                value="1"
              />
              <el-option
                label="发布"
                value="2"
              />
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px; padding: 0 2px;"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="handleAdd"
        @edit="handleEdit(arguments)"
        @release="handleRelease(arguments)"
        @revoke="handleRevoke(arguments)"
        @delete="handleDelete(arguments)"
        @view="handleView(arguments)"
        @dblclick="handleView(arguments)"
        @export="batchExport(masterList)"
      />
    </div>

    <!-- 新增 修改-->
    <add-edit-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditTitle"
      :dialog-visible.sync="dialogAddEditVisible"
      @reloadData="loadTableData()"
    />

    <!-- 查看 -->
    <view-dialog
      :data-id="id"
      dialog-title="查看"
      :dialog-visible.sync="dialogViewVisible"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 新增 修改
import addEditDialog from './components/addEditDialog'
// 查看
import viewDialog from './components/viewDialog'
// 题库API
import { loadQuestionListDataApi, exportQuestionListDataApi, updateStatusQuestionApi, deleteQuestionApi } from '@/api/v2/question'

export default {
  name: 'QuestionView',
  components: { CustomTable2, TableOperation2, addEditDialog, viewDialog },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data() {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'question_bank_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['question_bank_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['question_bank_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['question_bank_release'],
            prop: 'release',
            label: '发布',
            method: 'release'
          },
          {
            permissionSigns: ['question_bank_revoke'],
            prop: 'revoke',
            label: '撤销',
            method: 'revoke'
          },
          {
            permissionSigns: ['question_bank_del'],
            prop: 'delete',
            label: '作废',
            method: 'delete'
          },
          {
            permissionSigns: ['question_bank_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['question_bank_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          type: '',
          question: '',
          status: ''
        },
      },
      id: null,
      eventType: '',
      dialogAddEditVisible: false,
      dialogAddEditTitle: '',
      dialogViewVisible: false,
    }
  },
  created() {
    let _this = this;
    // 初始化主列表Table列
    _this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'typeValue', label: '问题类别', filterColumn: 'type', filterValue: 'type', filterArray: [{ label: '单选题', value: 2 }, { label: '多选题', value: 3 }, { label: '问答题', value: 4 }], width: 120 },
      { prop: 'question', label: '问题内容' },
      { prop: 'statusValue', label: '状态', filterColumn: 'status', filterValue: 'status', filterArray: [{ label: '草稿', value: 1 }, { label: '发布', value: 2 }], width: 90 },
      { prop: 'creatorName', filterColumn: 'creator_name', label: '创建人', width: 120 },
      { prop: 'createTime', filterColumn: 'create_time', label: '创建时间', width: 150, isBetween: true },
      { prop: 'operatorName', filterColumn: 'operator_name', label: '操作人', width: 120 },
      { prop: 'operationTime', filterColumn: 'operation_time', label: '操作时间', width: 150, isBetween: true }
    ]
    // 默认主列表Table列
    _this.getInitTableColumns()
    _this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData() {
      let _this = this;
      loadQuestionListDataApi(_this.masterList.tableQuery).then(response => {
        const { data } = response;
        _this.handleData(data.list || [])
        _this.masterList.tableDataTotal = data.total || 0
      }).catch()
    },
    // 新增
    handleAdd() {
      let _this = this;
      _this.eventType = 'add'
      _this.dialogAddEditTitle = '新增'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
    },
    // 修改
    handleEdit(args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要修改的问题', type: 'warning' })
        return
      } else if (args[0].status !== 1) {
        _this.$message({ message: '问题不在草稿状态，不能修改', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'edit'
      _this.dialogAddEditTitle = '修改'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
    },
    // 查看
    handleView(args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要查看的问题', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.dialogViewVisible = !_this.dialogViewVisible
    },
    // 发布
    handleRelease(args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要发布的问题', type: 'warning' })
        return
      } else if (args[0].status !== 1) {
        _this.$message({ message: '问题不在草稿状态，不能发布', type: 'warning' })
        return
      }
      _this.$confirm('是否确定发布该问题？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        updateStatusQuestionApi({ id: args[0].id, status: 2 }).then(() => {
          _this.$message({ message: '发布成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 撤销
    handleRevoke(args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要撤销发布的问题', type: 'warning' })
        return
      } else if (args[0].status !== 2) {
        _this.$message({ message: '问题不在发布状态，不能撤销', type: 'warning' })
        return
      }
      _this.$confirm('是否确定撤销发布该问题？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        updateStatusQuestionApi({ id: args[0].id, status: 1 }).then(() => {
          _this.$message({ message: '撤销成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 作废
    handleDelete(args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要作废的问题', type: 'warning' })
        return
      } else if (args[0].status !== 1) {
        _this.$message({ message: '问题不在草稿状态，不能作废', type: 'warning' })
        return
      }
      _this.$confirm('是否确定作废该问题？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        deleteQuestionApi({ id: args[0].id }).then(() => {
          _this.$message({ message: '作废成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 导出数据API
    exportByPage() {
      let _this = this;
      exportQuestionListDataApi(_this.exportObj).then((response) => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
